var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text-break"},[_vm._v(_vm._s(_vm.modalFormComponent.title))]),_c('property-form',{attrs:{"value":_vm.value,"fields":_vm.fields},on:{"input":_vm.doSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }